import { Button } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { FaCheckCircle, FaMinus, FaPlus } from 'react-icons/fa'
import { useNavigate } from 'react-router'
import CustomSwitch from '../../../component/CustomSwitch'
import { useDispatch, useSelector } from 'react-redux'
import { AuthContext } from '../../auth/AuthContext'
import { SubscriptionAPI } from '../../../api/SubscriptionAPI'
import { AccountSetupAPI } from '../../../api/AccountSetupAPI'
import { PlaftFormAPI } from '../../../api/PlatformAPI'
import { calendarTypePayload, isValidSetupData, planSavePayload } from '../../../util/accountSetup'
import { PLAN_COMPARE } from '../../../util/accountSetupCopy'
import { setSelectedClub } from '../../../redux/reducer/userReducer'

const PlanCard = ({ planInfo, finishLoading, startLoading,onToggle, isYear, applySetupData, isSelected, hasCurrentPlan }) => {
    const { getCurrentUser } = useContext(AuthContext);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userId = useSelector((state) => state.user.userInfo.userId);
    const selectedClub = useSelector((state) => state.user.selectedClub);
    const isFreeProduct = planInfo?.productName === 'Free';
    const compareCopy = isFreeProduct ? PLAN_COMPARE.free : PLAN_COMPARE.paid;
    const [totalCourt, setTotalCourt] = useState(1);
    const [freeFeeLabel, setFreeFeeLabel] = useState('');

    const increaseCourtNo = () => {
        setTotalCourt(totalCourt + 1);
    };
    const decreaseCourtNo = () => {
        if (totalCourt <= 1) {
            return;
        }
        setTotalCourt(totalCourt - 1);
    };

    useEffect(() => {
        if (planInfo?.productName !== 'Free') {
            return;
        }
        let cancelled = false;
        PlaftFormAPI.getPlatformFee('FREE')
            .then((response) => {
                if (!cancelled) {
                    setFreeFeeLabel(response?.Data?.displayLabel || '');
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setFreeFeeLabel('');
                }
            });
        return () => {
            cancelled = true;
        };
    }, [planInfo?.productName]);

    const persistCalendarType = async () => {
        if (!selectedClub?.clubId || !selectedClub?.calendarType) {
            return;
        }
        await AccountSetupAPI.putCalendarType(
            calendarTypePayload(selectedClub.clubId, selectedClub.calendarType)
        );
    };

    const handleUpdateFreePlan = async () => {
        const subInfo = {
            userId: userId,
            clubId: selectedClub?.clubId,
            planId: planInfo.planId
        }
        try {
            startLoading("loading7")
            await persistCalendarType();
            await SubscriptionAPI.postPurchaseFreeCoachPlan(subInfo);
            const response = await AccountSetupAPI.savePlan(planSavePayload(selectedClub?.clubId, {
                freePlan: true,
                calendarType: selectedClub?.calendarType,
            }));
            if (isValidSetupData(response?.Data) && typeof applySetupData === 'function') {
                applySetupData(response.Data);
            }
            dispatch(setSelectedClub({
                ...selectedClub,
                freePlanUser: true,
            }));
            getCurrentUser();
        } catch (error) {

        }finally{
            finishLoading("loading7")
        }
    }

    const createPaymentClientSecret = async () => {
            try {
                const planInfoObject = {
                    priceId: isYear ? planInfo?.yearlyPriceId : planInfo?.monthlyPriceId,
                    userId: userId,
                    clubId: selectedClub?.clubId,
                    subQuantity: totalCourt,
                    planId: planInfo?.planId,
                    isSubForPlatform: true,
                    planFor: planInfo?.planFor,
                }
                startLoading("loading7")
                try {
                    await persistCalendarType();
                    await AccountSetupAPI.savePlan(planSavePayload(selectedClub?.clubId, {
                        freePlan: false,
                        calendarType: selectedClub?.calendarType,
                    }));
                } catch (error) {
                    // Checkout still starts; calendar type is retried after payment.
                }
                const subscriptionResponse = await SubscriptionAPI.postPurchasePlan(planInfoObject);
                if (subscriptionResponse?.Data?.subscriptionId) {
                    navigate('/subscription-platform', {
                        replace: true,
                        state: {
                            subscriptionId: subscriptionResponse.Data.subscriptionId,
                            clientSecretKey: subscriptionResponse.Data.clientSecretKey
                        }
                    })
                }
            } catch (error) {
                console.error('error', error)
            }finally{
                finishLoading("loading7")
            }
        }


    return (
        <>
            <div className="manage_sub_price_details">
                {!isYear ?
                    <div className={`court_price_container${isSelected ? " is-selected-plan" : ""}`}>
                        {isSelected &&
                            <p className="selected-plan-badge" data-testid="selected-plan-badge">Your selected plan</p>}
                        <h3 className="court_price_details_heading">{compareCopy.name}</h3>
                        <h3>{compareCopy.price}</h3>
                        <p style={{ textAlign: 'center' }}>{compareCopy.points[0]}</p>
                        {planInfo?.planFor === "CLUB_RESERVATION" ?
                            <p className="court_price_per_court">
                                ${planInfo?.monthlyUnitAmount ? planInfo?.monthlyUnitAmount / 100 : 0} <span>per court</span>
                            </p>
                            :
                            <p className="court_price_per_court">
                                ${planInfo?.monthlyUnitAmount ? planInfo?.monthlyUnitAmount / 100 : 0} <span>per month</span>
                            </p>
                        }
                        {planInfo?.yearlyUnitAmount ?
                            <>
                                <br />
                                <CustomSwitch checked={isYear} onChange={(args) => onToggle(args.target.checked)} />
                            </>
                            :
                            <div style={{ height: '50px' }}>

                            </div>
                        }
                        <hr />
                        {planInfo?.planFor === "CLUB_RESERVATION" ?
                            <div className="select_court_no_body">
                                <p>Total court</p>
                                <div className="select_court_no_input">
                                    <button onClick={decreaseCourtNo}>
                                        <FaMinus className="select_court_no_input_icon" />
                                    </button>
                                    <span id="total_court_no">{totalCourt}</span>
                                    <button onClick={increaseCourtNo}>
                                        <FaPlus className="select_court_no_input_icon" />
                                    </button>
                                </div>
                            </div>
                            :
                        <div style={{ height: '60px' }}>

                        </div>
                            }
                        <div className="plan_features">
                            {Object.values(planInfo?.features || {}).filter(data=>data!=null).map((val, index) =>
                                <p key={index}>
                                    <FaCheckCircle className="plan_features_icon" />{val}
                                </p>
                            )}
                            {isFreeProduct &&
                                <>
                                    <p>
                                        <FaCheckCircle className="plan_features_icon" />{compareCopy.points[1]}
                                    </p>
                                    <p>
                                        <FaCheckCircle className="plan_features_icon" />{compareCopy.points[2]}
                                    </p>
                                </>}
                            {isFreeProduct && freeFeeLabel &&
                                <p data-testid="free-plan-fee-label">
                                    <FaCheckCircle className="plan_features_icon" />{freeFeeLabel}
                                </p>
                            }
                            {!isFreeProduct && compareCopy.points.slice(1).map((point) =>
                                <p key={point}>
                                    <FaCheckCircle className="plan_features_icon" />{point}
                                </p>
                            )}

                        </div>
                        {!hasCurrentPlan &&
                        <div className="court_plan_purchase_btn">
                            <Button
                                onClick={() => {
                                    if (planInfo.productName === 'Free') {
                                        handleUpdateFreePlan();
                                    } else {
                                        createPaymentClientSecret();
                                    }
                                }
                                }
                                fullWidth
                                variant="contained"
                            >
                                {planInfo.productName === 'Free' ? 'try free' : '30 days free trial'}
                            </Button>
                        </div>}
                        <svg
                            className="admin-sub-details-dollar-sign"
                            width="40"
                            height="40"
                            fill="none"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                        >
                            <path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                        </svg>
                    </div>
                    :
                    <div className={`court_year_price_container${isSelected ? " is-selected-plan" : ""}`}>
                        {isSelected &&
                            <p className="selected-plan-badge" data-testid="selected-plan-badge">Your selected plan</p>}
                        <h3 className="court_year_price_details_heading">{compareCopy.name}</h3>
                        <h3>{compareCopy.price}</h3>
                        <p style={{ textAlign: 'center' }}>{compareCopy.points[0]}</p>
                        {planInfo?.planFor === "CLUB_RESERVATION" ?
                            <p className="court_year_price_per_court">
                                ${planInfo?.yearlyUnitAmount ? planInfo?.yearlyUnitAmount / 100 : 0} <span>per court</span>
                            </p>
                            :
                            <p className="court_year_price_per_court">
                                ${planInfo?.yearlyUnitAmount ? planInfo?.yearlyUnitAmount / 100 : 0} <span>per year</span>
                            </p>}
                        <br />
                        <CustomSwitch checked={isYear} onChange={(args) => onToggle(args.target.checked)} />
                        <hr />
                        {planInfo?.planFor === "CLUB_RESERVATION" ?
                            <div className="select_court_no_body">
                                <p>Total court</p>
                                <div className="select_court_no_input">
                                    <button onClick={decreaseCourtNo}>
                                        <FaMinus className="select_court_no_input_icon" />
                                    </button>
                                    <span id="total_court_no">{totalCourt}</span>
                                    <button onClick={increaseCourtNo}>
                                        <FaPlus className="select_court_no_input_icon" />
                                    </button>
                                </div>
                            </div>
                            :
                            <div style={{height:'40px'}}>

                            </div>
                            }
                        <div className="plan_features">
                            {Object.values(planInfo?.features || {}).filter(data => data != null).map((val, index) =>
                                <p key={index}>
                                    <FaCheckCircle className="plan_features_icon" />{val}
                                </p>
                            )}
                            {isFreeProduct &&
                                <>
                                    <p>
                                        <FaCheckCircle className="plan_features_icon" />{compareCopy.points[1]}
                                    </p>
                                    <p>
                                        <FaCheckCircle className="plan_features_icon" />{compareCopy.points[2]}
                                    </p>
                                </>}
                            {isFreeProduct && freeFeeLabel &&
                                <p data-testid="free-plan-fee-label">
                                    <FaCheckCircle className="plan_features_icon" />{freeFeeLabel}
                                </p>
                            }
                            {!isFreeProduct && compareCopy.points.slice(1).map((point) =>
                                <p key={point}>
                                    <FaCheckCircle className="plan_features_icon" />{point}
                                </p>
                            )}
                        </div>
                        {!hasCurrentPlan &&
                        <div className="court_year_plan_purchase_btn">
                            <Button
                                onClick={() => {
                                    if (planInfo.productName === 'Free') {
                                        handleUpdateFreePlan();
                                    } else {
                                        createPaymentClientSecret();
                                    }
                                }
                                }
                                fullWidth
                                variant="contained"
                            >
                                {planInfo.productName === 'Free' ? 'try free' : '30 days free trial'}
                            </Button>
                        </div>}
                        <svg
                            className="admin-sub-details-dollar-sign"
                            width="40"
                            height="40"
                            fill="none"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                        >
                            <path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                        </svg>
                    </div>
                }
            </div>
        </>
    )
}

export default PlanCard